module.exports = "<p>\r\n  gestioncuisine works!\r\n</p>\r\n"